// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__600pU","modal":"Modal_modal__shkSZ","close":"Modal_close__23se_"};